<template>
  <v-app dark id="app">
    <Home />
  </v-app>
</template>

<style lang="sass">
@import './App.scss'
</style>

<script>
import Vue from 'vue';
import Vuetify from 'vuetify';
import Home from '@/components/Home';

Vue.use(Vuetify);

export default {
  name: 'app',
  methods: {},
  watch: {},
  components: {
    Home
  }
};
</script>
